import { ElementType } from "../../library-js/dom-tools/ElementType";
import { InspectorField } from "./fields/InspectorField";
import { InspectorCreationInfo } from "./InspectorCreationInfo";
import { InspectorLibrary } from "./InspectorLibrary";

export class Inspector
{
  static readonly type = new ElementType( "inspector--element" );
  
  element:Element;
  root:any;
  fields:InspectorField<any>[] = [];
}